import React from "react";
import TabellaOrariAcq from "./TabellaOrariAcq";
import TabellaOrariAvv from "./TabellaOrariAvv";
import TabellaOrariBR from "./TabellaOrariBR";
import TabellaOrariAdulti from "./TabellaOrariAdulti";
import "../../styles/Accordion.css"
import TabellaOrariPreParto from "./TabellaPreParto";
import TabellaOrariPreAgo from "./TabellaPreAgo";
import Space from "../../commons/Space";
import PrezziAdulti from "./PrezziAdulti";
import SpaceL from "../../commons/SpaceL";
import {useNavigate} from "react-router-dom";
import AllertIscrizione from "../multitessere/AllertIscrizione";
import AcqTablePrezzi from "./AcqTablePrezzi";
import BRTablePrezzi from "./BRTablePrezzi";
import AllertIscrizione6 from "../multitessere/AllertIscrizione6";
import AdultiTablePrezzi from "./AdultiTablePrezzi";


function NuotoCorsiSezioni() {
    const navigate = useNavigate();
    return(
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample">
                <div className="accordion-item">
                    <h2 className="accordion-header d-flex flex-row" id="flush-headingOne" style={{ justifyContent: "center", textAlign: "center" }}>
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            ACQUATICITÀ  (6 - 36 mesi)
                        </button>

                    </h2>
                    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>ORARI</h3>
                            <TabellaOrariAcq />
                            <SpaceL/>
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>PREZZI</h3>
                            <AcqTablePrezzi />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            AVVIAMENTO SCUOLA NUOTO <br className="d-block d-sm-none"></br>(3 - 5 anni)
                        </button>
                    </h2>
                    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>ORARI</h3>
                            <TabellaOrariAvv />
                            <SpaceL/>
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>PREZZI</h3>
                            <AcqTablePrezzi />


                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                            BAMBINI E RAGAZZI (6 - 14 anni)
                        </button>
                    </h2>
                    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>ORARI</h3>
                            <TabellaOrariBR />
                            <SpaceL/>
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>PREZZI</h3>
                            <BRTablePrezzi />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFive">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                        AGONISMO
                    </button>
                </h2>
                <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>ORARI</h3>
                        <TabellaOrariPreAgo />
                        <SpaceL />
                        <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>PREZZI</h3>
                        <div className="d-flex flex-column m-auto"style={{maxWidth: "50em"}}>
                            <div className="table-container">
                                <table className="table text-center m-auto" style={{maxWidth: "15em"}}>
                                    <thead >
                                    <tr >
                                        <th scope="col" style={{width: "25%"}}>
                                            Stagionale
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr style={{backgroundColor: "#F8F8F8"}}>
                                        <td className={"data-cell"}>1100€</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <SpaceL/>
                                <div className="alert alert-primary d-flex align-items-center m-auto" role="alert">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-info-circle-fill flex-shrink-0" viewBox="0 0 16 16">
                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                                    </svg>
                                    <div className="text-center" style={{ marginLeft: "1em" }}>
                                        <strong>Obbligatorio </strong> certificato medico sportivo agonistico <br />
                                    </div>
                                </div>
                                <br/>
                            </div>
                        </div>
                        <p className="text-center" style={{padding: "0 3em 0 3em"}}>
                            Corso di <strong>nuoto avanzato</strong> rivolto ai ragazzi che sappiano già nuotare tutti i quattro stili
                            <br/>
                            <br/>Possibilità di partecipare a competizioni <strong>FIN/UISP</strong>
                            <br/>
                            <br/>
                            Durante i mesi estivi e il periodo natalizio accesso al nuoto libero
                            <br/>
                            <br/>
                            Allenatore <strong>Stefano Moscardi</strong> (brevettato capo allenatore FIN)
                            <br/>
                            <br/>


                            {/* <strong>Quota annuale complessiva</strong> 900 € + iscrizione 30 €
                            <br/> */}
                            <SpaceL />
                            <div className="text-center">
                                <a onClick={()=> navigate("./garepreagonistica")}  className="text-center" style={{ cursor:"pointer", fontSize: "22px", padding: "1em", fontFamily: "Hammersmith One", color: "#032041" }}> Risultati gare </a>
                            </div>

                        </p>
                    </div>
                </div>
            </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFour">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                            ADULTI
                        </button>
                    </h2>
                    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>ORARI</h3>
                            <TabellaOrariAdulti />
                            <br/>
                            <SpaceL/>
                            <h3 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>PREZZI</h3>
                            <AdultiTablePrezzi />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingSix">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                            PREPARTO
                        </button>
                    </h2>
                    <div id="flush-collapseSix" className="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            <TabellaOrariPreParto />
                            <hr/>
                            <p className="text-center" style={{marginTop: "2em"}}>
                                Il corso prevede una parte di ginnastica a secco e una parte in vasca (acqua alta e acqua bassa)
                                <br/>
                                Si richiede buona capacità di galleggiamento
                                <br/>
                                <br/>
                                <b>Cosa portare?</b>
                                <br/>
                                Abbigliamento ginnico, costume, cuffia, asciugamano, ciabatte
                                <br/>
                                <SpaceL/>

                                <div className="d-flex flex-column m-auto"style={{maxWidth: "50em"}}>
                                    <div className="table-container">
                                        <table className="table text-center m-auto" style={{maxWidth: "30em"}}>
                                            <thead >
                                            <tr >
                                                <th scope="col" style={{width: "25%"}}>
                                                    Lezione singola
                                                </th>
                                                <th scope="col" style={{width: "25%"}}>
                                                    10 lezioni
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr style={{backgroundColor: "#F8F8F8"}}>
                                                <td className={"data-cell"}>15€</td>
                                                <td className={"data-cell"}>130€</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <SpaceL/>
                                        <div className="alert alert-primary d-flex align-items-center m-auto" role="alert">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-info-circle-fill flex-shrink-0" viewBox="0 0 16 16">
                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                                            </svg>
                                            <div className="text-center" style={{ marginLeft: "1em" }}>
                                                <strong>Obbligatorio </strong> certificato medico sportivo agonistico <br />
                                            </div>
                                        </div>
                                        <br/>
                                    </div>
                                </div>

                                <br/>
                                *richiesto certificato ginecologico
                            </p>
                        </div>
                    </div>
                </div>

        </div>
    )
}

export default NuotoCorsiSezioni
